import axios from "axios";
import NProgress from "nprogress";
import router from "@/router"; // make sure this path is correct
import { csrfToken, ensureCsrf, clearSessionState } from '@/services/session';

const API_URL = '/pilot-api/';

const axiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

axiosInstance.interceptors.request.use(async (config) => {
  NProgress.start();
  delete config.headers.Authorization;
  delete config.headers.authorization;
  if (!['get', 'head', 'options'].includes((config.method || 'get').toLowerCase()) || config.url === 'refresh-token') config.headers['X-CSRF-Token'] = await ensureCsrf();
  else if (csrfToken()) config.headers['X-CSRF-Token'] = csrfToken();
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    NProgress.done();

    if (
      response?.data?.success === false &&
      [1020, 1026].includes(response?.data?.errors?.error_code)
    ) {
      clearSessionState();
      router.push("/login");
    }

    return response;
  },
  (error) => {
    NProgress.done();

    if (error.response?.status === 401) {
      clearSessionState();

      router.push("/login");
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
